<template>
    <div class="p-3 row justify-content-center" v-if="!error">
        <el-card class="col-12" :header="company.id ? company.name:'Procurando Empresa'">
            <el-skeleton :loading="loading" animated :rows="12">
                <template #default>
                    <el-form disabled v-if="company" :model="company" label-position="top" :rules="rules" ref="formRef">
                        <el-row :gutter="30">
                            <el-col :sm="24" :md="12" :lg="10">
                                <el-form-item label="Nome da empresa" prop="name">
                                    <el-input name="name" v-model="company.name" />
                                </el-form-item>
        
                                <el-form-item label="Descricao da empresa" prop="description">
                                    <el-input type="textarea" name="description" v-model="company.description" />
                                </el-form-item>

                                <el-form-item label="Cadastrado">
                                    Por&emsp;<b>{{ company.user?.name }}</b>, em&emsp;<b> {{ company.created_at ? new Date(company.created_at).toLocaleString():'-' }}</b>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="24" :md="12" :lg="14">
                                <el-form-item label="Local" prop="area.name" v-if="company.area">
                                    <el-input name="area" v-model="company.area.name" />
                                </el-form-item>
                                <div style="height: 400px; width: 100%" class="position-relative">
                                    <LMap ref="map" v-if="company.area" :zoom="16" :center="[company.area.lat, company.area.long]">
                                        <LTileLayer
                                            url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga"
                                            layer-type="base"
                                            name="OpenStreetMap"
                                        ></LTileLayer>

                                        <LMarker v-if="company.area" :lat-lng="[company.area.lat, company.area.long]">
                                            <LTooltip>{{ company.name }}</LTooltip>
                                        </LMarker>
                                    </LMap>
                                </div>
                                <ElFormItem label="Logotipo" prop="image">
                                    <img style="max-height: 250px; max-width: 100%;" :src="(company.image as string)" />
                                </ElFormItem>
                            </el-col>
                        </el-row>
                    </el-form>
                    <ElButton type="primary" native-type="button" @click="travels">Ver viagens</ElButton>
                    <ElRow>
                        <ElCol :sx="24" :md="12" class="p-4">
                            <h4>Carros</h4>
                            <PersonalTable :loading="loading" :height="450" :showRows="10" :cols="[
                                {label: '#', prop: 'id'},
                                {label: 'Referencia', prop: 'reference'},
                                {label: 'Nome', prop: 'name'},
                                {label: 'Placa', prop: 'plate'},
                            ]" :data="cars" >
                            </PersonalTable>
                        </ElCol>
                        <ElCol :sx="24" :md="12" class="p-4">
                            <h4>Preços</h4>
                            <PersonalTable :loading="loading" :height="450" :showRows="10" :cols="[
                                {label: '#', prop: 'id'},
                            ]" :data="company.segments" >
                                <el-table-column label="Trecho" class-name="auto" :min-width="150">
                                    <template #default="data">
                                        {{ data.row.from.name }} - {{ data.row.to.name }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Preço" class-name="auto" :min-width="150">
                                    <template #default="data">
                                        {{ data.row.pivot.price }} MT
                                    </template>
                                </el-table-column>
                            </PersonalTable>
                        </ElCol>
                    </ElRow>
                </template>
            </el-skeleton>
        </el-card>

    </div>
</template>

<script setup lang="ts">
    import Api from '@/services/api';
    import { Car, Event, TravelCompany } from '@/services/types';
    import { ElButton, ElMessage, ElRow, FormInstance, FormRules, ElCol, ElInput, ElFormItem } from 'element-plus';
    import { onBeforeMount, reactive, ref } from 'vue';
    import "leaflet/dist/leaflet.css";
    import { LMap, LTileLayer, LMarker, LTooltip} from "@vue-leaflet/vue-leaflet"
    import PersonalTable from '@/components/PersonalTable.vue';
import { useRouter } from 'vue-router';


    const loading = ref<boolean>(true)
    const formRef = ref<FormInstance>()
    const apiImage = ref<string>()
    const cars = ref<Array<Car>>([])
    const error = ref<boolean>(false)
    const router = useRouter()

    const travels = () => router.push('/companies-dashboard/travel')
    
    const company = reactive<TravelCompany>({
        description: '',
        image: null,
        name: '',
        area: {lat: 0, long: 0, name: ''},
        id: 0,
        user: undefined,
        segments: [],
        phone: null,
        password: null
    })

    const getImageUrl = (image: string) => `${Api.publicUrl}alt-storage?path=travel_companies/${image}`

    const rules = ref<FormRules<Event>>({
        name: [{required: true, message: 'Preencha este campo'}],
        description: [{required: true, message: 'Preencha este campo'}],
        "area.name": [{required: true, message: 'Preencha este campo'}],
    })

    const password = sessionStorage.getItem('password')
    const phone = sessionStorage.getItem('phone')

    const getCompany = async () => {
        const res = await Api.get(`companies?phone=${phone}&password=${password}`)

        if (res.status == 200) {
            const data = res.data.company
    
            company.id = data.id
            company.area = data.area
            company.user = data.user
            company.name = data.name
            company.phone = data.phone
            company.description = data.description
            company.created_at = data.created_at
            company.segments = data.trip_segments
            cars.value = data.cars

            apiImage.value = getImageUrl(data.image)
            company.image = apiImage.value
            error.value = false
            console.log(data)
        } else {
            console.log(res)
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
            error.value = true
        }
    }

    onBeforeMount(async () => {
        loading.value = true
        await Promise.all([
            getCompany(),
        ])
        loading.value = false
    })
</script>

<style lang="scss" scoped>
    table.list-tickets {
        width: 100% !important;
    }
    table.list-tickets td {
        padding-top: 10px;
        padding-bottom: 10px;
    }
    table.list-tickets tr {
        border-bottom: 1px solid gray;
    }
</style>